import { gql } from "@apollo/client";

export const manufacturerQuery = gql`
  query manufacturer($id: ID!) {
    manufacturer(id: $id) {
      id
      name
    }
  }
`;

export const manufacturerListQuery = gql`
  query manufacturerList {
    manufacturerList(pagination: { limit: 999 }) {
      edges {
        id
        name
      }
    }
  }
`;

export const createManufacturerMutation = gql`
  mutation createManufacturer($input: CreateManufacturerInput!) {
    createManufacturer(input: $input) {
      id
      name
    }
  }
`;

export const deleteManufacturerMutation = gql`
  mutation deleteManufacturer($input: DeleteManufacturerInput!) {
    deleteManufacturer(input: $input) {
      id
      name
    }
  }
`;

export const updateManufacturerMutation = gql`
  mutation updateManufacturer($input: UpdateManufacturerInput!) {
    updateManufacturer(input: $input) {
      id
      name
    }
  }
`;
